import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  header: {
    backgroundColor: theme.palette.primaryPure,
    height: '140px',
  },
  icon: {
    '& path': {
      fill: 'white',
    },
  },
  userIcon: {
    '& path': {
      fill: 'white',
    },
    paddingRight: theme.spacing.xSmall,
  },
  userDataContainer: {
    transform: 'translate(0, -70%)',
  },
}));

export default useStyles;
